

































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule, UserModule, CanteenModule } from '../../store'
import { findItemForTree, getAllFatherNodeForTree } from '../../utils/toolsForCommon'
import countTo from 'vue-count-to'
import html2canvas from 'html2canvas'
import DateUtil from '../../utils/toolsForDate'
@Component({
  name: 'Voucher',
  components: {
    'voucher-table': () => import('../../components/voucherTable/index.vue'),
    'empty-container': () => import('../../components/empty.vue'),
    'count-to': countTo,
    'my-dialog': () => import('../../components/common/myDialog.vue')
  },
  filters: {
    filterForNameByStatus: function (status: number): string {
      // 状态；0表示未审批，1表示审批通过，2表示审批驳回
      let res = ''
      switch (status) {
        case 0:
          res = '未审核'
          break
        case 1:
          res = '审核通过'
          break
        case 2:
          res = '审核不通过'
          break
      }
      return res
    }
  }
})
export default class Voucher extends Vue {
  public loadingForVoucherTable: boolean = false
  public printForVoucherTable: any = {
    id: 'accountingVoucherTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  // 头部条目相关：
  public headerForOperationForListInnerList: Array<string> = ['box_list_before', 'box_list', 'box_list_after']
  public tableDataList: any[] = []
  public pageNo: number = 1
  public pageSize: number = 5
  public total: number = 0
  public loadingForTableDataList: boolean = false
  // 月份选择：
  public monthForDate: string = ''
  // 凭证详情：
  public voucherTableDetail: any = {}
  // 凭证审核：
  public dialogFlagForVoucherAudit: boolean = false
  public loadingForVoucherAudit: boolean = false
  public auditResult: boolean | string = ''
  public auditReason: string = ''
  // 更多凭证相关：
  public radioForStatus: number | string = ''
  public inputForSummary: string = ''
  public checkboxForCheckAll: boolean = false
  public flagForLookVoucherMore: boolean = false

  get batch (): string {
    let res = ''
    if (this.monthForDate) {
      res = this.monthForDate.split('-')[0] + this.monthForDate.split('-')[1]
    }
    return res
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async mounted (): Promise<void> {
    this.getLastMonth()
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    setTimeout(() => {
      const voucherTableContainer = document.querySelector('.voucher_table_container') as HTMLElement
      voucherTableContainer.classList.remove('animate__animated')
      voucherTableContainer.classList.remove('animate__backInUp')
    }, 1000)
    this.getTableDataList()
  }

  getLastMonth () {
    this.monthForDate = DateUtil.getLastMonth()
  }

  // 查询凭证：
  async getTableDataList () {
    try {
      this.loadingForTableDataList = true
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        schoolIds: [this.userInfo.organizationId],
        // type: 0, // 凭证的类型；0:流水凭证；1：结转凭证，不用传，不然就查不出来结转凭证了
        batch: this.batch
      }
      if (this.flagForLookVoucherMore) {
        Object.assign(params, {
          status: this.radioForStatus,
          summary: this.inputForSummary
        })
      }
      const { data: result } = await (this as any).$http.financeProofQuery(params)
      this.loadingForTableDataList = false
      if (result.code !== 200) {
        this.total = 0
        this.tableDataList = []
        return this.$message.error(result.msg === '该流水记录未生成对应的凭证' ? '未查询到相关凭证' : result.msg)
      }
      this.tableDataList = ((result.data && result.data.records) || []).map(item => {
        // 处理凭证：
        let info = {
          ...item,
          time: item.date,
          checked: false
        }
        // 处理贷方金额和借方金额：
        info.items = info.items.map(v => {
          if (v.credit) {
            // console.log('贷方金额')
            // console.log(v.credit)
            // const creditNum = Number(v.credit) * 100
            const creditNum = String(v.credit).replace('.', '')
            const creditNumArr = String(creditNum).split('')
            v.creditList = (new Array(14 - creditNumArr.length).fill('-')).concat(creditNumArr)
          } else {
            v.creditList = (new Array(14).fill('-')).concat([])
          }
          if (v.debit) {
            // console.log('借方金额')
            // console.log(v.debit)
            // const debitNum = Number(v.debit) * 100
            const debitNum = String(v.debit).replace('.', '')
            const debitNumArr = String(debitNum).split('')
            v.debitList = (new Array(14 - debitNumArr.length).fill('-')).concat(debitNumArr)
          } else {
            v.debitList = (new Array(14).fill('-')).concat([])
          }
          // 还要处理科目：
          if (v.subjectStr) {
            // console.log(v.subject)
            // console.log(v.subjectStr)
            // console.log(this.treeDataForDisposeNameSubject)
            // console.log(getAllFatherNodeForTree(this.treeDataForDisposeNameSubject, 'children', 'code', v.subject))
            const subjectStrArr = getAllFatherNodeForTree(this.treeDataForDisposeNameSubject, 'children', 'code', v.subject).map(vv => {
              // console.log(findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', vv))
              return findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', vv)
            }).map(vvv => vvv.orginName)
            // console.log(subjectStrArr)
            v.subjectStr = v.subject + ' ' + subjectStrArr.join('/')
          }
          return v
        })
        // 处理合计：
        if (info.summation) {
          // const summationNum = Number(info.summation) * 100
          const summationNum = String(info.summation).replace('.', '')
          const summationNumArr = String(summationNum).split('')
          info.summationList = (new Array(14 - summationNumArr.length).fill('-')).concat(summationNumArr)
        } else {
          info.summationList = (new Array(14).fill('-')).concat([])
        }
        // 处理凭证号码：
        if (info.codeNum) {
          const codeNumArr = String(info.codeNum).split('')
          const codeNumForDispose = (new Array(4 - codeNumArr.length).fill('0')).concat(codeNumArr)
          info.codeNum = codeNumForDispose.join('') + '号'
        }
        return info
      })
      // console.log(this.tableDataList)
      this.total = result.data.total
      this.checkboxForCheckAll = false
      // 优化，默认展示一张凭证：
      if (this.tableDataList.length) {
        this.operationForClickTheItem(this.tableDataList[0])
      }
    } catch (err) {
      console.log(err)
    }
  }

  downForVoucherTable (): void {
    this.$nextTick(async () => {
      this.loadingForVoucherTable = true
      let _that: any = this
      let ele = document.querySelector('#accountingVoucherTable') as any
      let width = ele.offsetWidth
      let height = ele.offsetHeight
      let scale = 6
      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft // 获取滚动轴滚动的长度
      const rect = ele.getBoundingClientRect() // 获取元素相对于视口的
      let canvas = await html2canvas(ele, {
        width,
        height,
        scale,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, // 允许跨域图片
        logging: false,
        x: rect.left, // 绘制的dom元素相对于视口的位置
        y: rect.top,
        scrollX: -scrollLeft, // 滚动的长度
        scrollY: 0
      })
      let imgUrl = canvas.toDataURL('image/png')
      // 下载：
      var eleLink = document.createElement('a')
      eleLink.href = imgUrl // 转换后的图片地址
      eleLink.download = '《记账凭证》.png'
      document.body.appendChild(eleLink)
      eleLink.click()
      document.body.removeChild(eleLink)
      _that.$message.success('下载成功')
      this.loadingForVoucherTable = false
    })
  }

  operationForChangeBoxList (type: string) {
    const headerForOperationForListInner = this.$refs.headerForOperationForListInner as any
    switch (type) {
      case 'pre':
        if (this.pageNo < 2) {
          this.$message.warning('已经是第一页啦！')
        } else {
          this.pageNo--
          headerForOperationForListInner.classList.add('animation_to_right')
          setTimeout(() => {
            headerForOperationForListInner.classList.remove('animation_to_right')
          }, 500)
          this.getTableDataList()
        }
        break
      case 'next':
        const totalPages = Math.ceil(this.total / this.pageSize)
        if (!totalPages) return this.$message.warning('抱歉，没有更多数据哦！')
        if (this.pageNo >= totalPages) {
          if (totalPages > 1) {
            this.$message.warning('没有下一页啦！')
          } else {
            this.$message.warning('抱歉，没有更多数据哦！')
          }
        } else {
          this.pageNo++
          headerForOperationForListInner.classList.add('animation_to_left')
          setTimeout(() => {
            headerForOperationForListInner.classList.remove('animation_to_left')
          }, 500)
          this.getTableDataList()
        }
        break
    }
  }

  operationForClickTheItem (item: any): void {
    this.tableDataList = this.tableDataList.map(v => {
      if (v.journalAccountId === item.journalAccountId) {
        v.active = true
      } else {
        v.active = false
      }
      return v
    })
    this.loadingForVoucherTable = true
    setTimeout(() => {
      this.loadingForVoucherTable = false
      this.voucherTableDetail = item
      let messageText = '获取凭证数据成功'
      let messageType = 'success'
      if (!Object.keys(this.voucherTableDetail).length) {
        messageText = '抱歉，暂无凭证数据哦！'
        messageType = 'warning'
      }
      this.$message[messageType](messageText)
    }, 500)
  }

  // 选择月份：
  changeForMonthForDate (value): void {
    this.pageNo = 1
    this.voucherTableDetail = {}
    this.getTableDataList()
  }

  filterForColorByStatus (status: number): string {
    // 状态；0表示未审批，1表示审批通过，2表示审批驳回
    let res = ''
    switch (status) {
      case 0:
        res = 'gray'
        break
      case 1:
        res = 'rgb(46, 189, 46)'
        break
      case 2:
        res = 'rgb(243, 70, 70)'
        break
    }
    return res
  }

  filterForTagTypeByStatus (status: number): string {
    // 状态；0表示未审批，1表示审批通过，2表示审批驳回
    let res = ''
    switch (status) {
      case 0:
        res = 'info'
        break
      case 1:
        res = 'success'
        break
      case 2:
        res = 'danger'
        break
    }
    return res
  }

  // 凭证审核：
  operationForVoucherAudit () {
    if (!Object.keys(this.voucherTableDetail).length) return this.$message.warning('请先选择凭证哦！')
    this.dialogFlagForVoucherAudit = true
  }

  operationForVoucherAuditForSome () {
    const checkedList = this.tableDataList.filter(item => item.checked)
    if (!checkedList.length) return this.$message.warning('请选择需要进行审核的项')
    this.dialogFlagForVoucherAudit = true
    console.log(checkedList)
  }

  // 确定审核：
  async confirmVoucherAudit () {
    try {
      let journalAccountList = []
      // 通过单个还是批量进行判断：
      if (this.flagForLookVoucherMore) {
        journalAccountList = this.tableDataList.filter(item => item.checked)
      } else {
        journalAccountList = [this.voucherTableDetail]
      }
      if (this.auditResult === '') return this.$message.warning('请选择通过与否')
      if (!this.auditResult && !this.auditReason) return this.$message.warning('不通过请输入审核理由')
      const params = {
        journalAccountIds: journalAccountList.map(item => item.journalAccountId),
        audit: this.auditResult,
        reason: this.auditReason
      }
      this.loadingForVoucherAudit = true
      const { data: result } = await (this as any).$http.financeProofAduit(params)
      this.loadingForVoucherAudit = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('审核完成')
      this.dialogFlagForVoucherAudit = false
      this.voucherTableDetail = {}
      this.getTableDataList()
    } catch (err) {
      console.log(err)
    }
  }

  hoverWithCircleScaleByMouseEnter (event) {
    event.target.classList.add('hover_with_circle_scale')
  }

  hoverWithCircleScaleByMouseLeave (event) {
    event.target.classList.remove('hover_with_circle_scale')
  }

  handleCurrentChange (currentPage: number): void {
    this.pageNo = currentPage
    this.getTableDataList()
  }

  changeForCheckboxForCheckAll (value) {
    this.tableDataList = this.tableDataList.map(item => {
      item.checked = value
      return item
    })
  }

  changeForCheckboxForCheckOne (event, v) {
    const checkedLength = this.tableDataList.filter(item => item.checked).length
    if (checkedLength === this.tableDataList.length) {
      this.checkboxForCheckAll = true
    } else {
      this.checkboxForCheckAll = false
    }
  }

  changeForRadioForStatus () {
    this.pageNo = 1
    this.voucherTableDetail = {}
    this.getTableDataList()
  }

  searchForInputForSummary () {
    this.pageNo = 1
    this.voucherTableDetail = {}
    this.getTableDataList()
  }

  lookVoucherMore () {
    this.flagForLookVoucherMore = true
    this.pageNo = 1
    this.pageSize = 20
    this.voucherTableDetail = {}
    this.getTableDataList()
  }

  lookVoucherOne () {
    this.flagForLookVoucherMore = false
    this.pageNo = 1
    this.pageSize = 5
    this.voucherTableDetail = {}
    this.getTableDataList()
  }
}
